import React, { useEffect, useState } from "react";
import Applayout from "./layout/applayout";
import Modal from "../components/app/modal";
import { Link, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axiosClient from "../axios/axiosClient";
import { toast } from "react-toastify";
import Loader from "../components/app/loader";
import Swal from 'sweetalert2';

function BeneficiaryCases() {
  const [modalTitle, setModalTitle] = useState("Edit Profile");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [editCaseId, setEditCaseId] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    amount: "",
    description: "",
    beneficiary_id: id,
    currency: "",
    amount_in_local: "",
    local_rate: "",
    created_at: new Date().toISOString().split('T')[0]
  });
  const [value, setValue] = useState("");

  const [cases, setCases] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, per_page: 10 });

  const round = (num, decimalPlaces = 0) => {
      num = Math.round(num + "e" + decimalPlaces);
      return Number(num + "e" + -decimalPlaces);
  }

  const handleInputChange = (e) => {
    if(e.target.name == 'amount_in_local'){
      setFormData({
        ...formData,
        'amount' : round(e.target.value/formData.local_rate, 2),
        [e.target.name]: e.target.value,
      });
    }else{
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const setCurrenctCase = (data) => {
    // Format the created_at date to work with datetime-local input
    const formattedDate = data.created_at ? new Date(data.created_at).toISOString().slice(0, 16) : '';
    
    setFormData({
      ...data,
      created_at: formattedDate // This will format like: "2024-03-20T15:30"
    });
    setValue(data.description);
  }

  const resetFormData = () => {
    setFormData({
      title: "",
      amount: "",
      description: "",
      currency: "",
    });
    setValue("")
  };

  const handleSave = () => {
    const dataToSubmit = {
      ...formData,
      description: value,
    };

    if (editCaseId) {
      axiosClient
        .put(`/beneficiary-cases/${editCaseId}`, dataToSubmit)
        .then((response) => {
          resetFormData();
          getBeneficiaryCases();
          setLoading(false);
          toast.success(response.data.data.message);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    } else {
      axiosClient
        .post(`/beneficiary-cases`, dataToSubmit)
        .then((response) => {
          resetFormData();
          getBeneficiaryCases();
          setLoading(false);
          toast.success(response.data.data.message);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };

  const getBeneficiaryCases = () => {
    axiosClient
      .get(`/beneficiaries/${id}`)
      .then((response) => {
        setCases(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this! All associated documents will also be deleted.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient.delete(`/beneficiary-cases/${id}`)
          .then((response) => {
            getBeneficiaryCases();
            setLoading(false);
            toast.success('Case deleted successfully');
          })
          .catch((error) => {
            setLoading(false);
            const errorMessage = error.response?.data?.message || 'Error deleting case';
            toast.error(errorMessage);
          });
      }
    });
  };

  useEffect(() => {
    // Beneficiary's cases
    setLoading(true);
    getBeneficiaryCases();
  }, []);

  return (
    <Applayout>
      <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>Beneficiary Cases</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i data-feather="home"></i>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Idris's Cases</li>
                  <li className="breadcrumb-item active">Default</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">
            {cases.first_name + " " + cases.last_name}'s Case(s)
            <div className="pull-right">
              <span style={{fontSize:"12px"}} className="mx-3">Total Amount Recieved : <span className="badge badge-danger">${cases?.beneficiary_cases_sum_amount?.toLocaleString() || 0}</span></span>
              <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#myModal"
                onClick={() => {setModalTitle("Make Case"); setEditCaseId("")}} 
              >
                Make Case
              </button>
            </div>
          </h4>

          <div className="card-options">
            <a
              className="card-options-collapse"
              href="edit-profile.html#"
              data-toggle="card-collapse"
            >
              <i className="fe fe-chevron-up"></i>
            </a>
            <a
              className="card-options-remove"
              href="edit-profile.html#"
              data-toggle="card-remove"
            >
              <i className="fe fe-x"></i>
            </a>
          </div>
        </div>
        {!loading ?(<div className="table-responsive">
          <table className="table card-table table-vcenter text-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Project Officer</th>
                <th>Case Manager</th>
                <th>Amount Needed</th>
                <th>Status</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {cases.beneficiary_cases &&
                cases.beneficiary_cases.map((cas, index) => {
                  // Calculate the correct index based on current page
                  const currentPage = pagination.current_page;
                  const perPage = pagination.per_page;
                  const correctIndex = (currentPage - 1) * perPage + index + 1;

                  const getStatusBadgeClass = (status) => {
                    switch (status.toLowerCase()) {
                      case "pending":
                        return "badge bg-warning text-dark";
                      case "in-progress":
                        return "badge bg-primary";
                      case "in-review":
                        return "badge bg-info text-dark";
                      case "completed":
                        return "badge bg-success";
                      case "declined":
                        return "badge bg-danger";
                      default:
                        return "badge bg-secondary";
                    }
                  };

                  // Format the date
                  const formatDate = (dateString) => {
                    const options = { 
                        year: 'numeric', 
                        month: 'short', 
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    };
                    return new Date(dateString).toLocaleDateString('en-US', options);
                  };

                  return (
                    <tr key={cas.id}>
                      <td>{correctIndex}</td>
                      <td>{cas.title}</td>
                      <td>
                        {cas.project_officer.first_name +
                          " " +
                          cas.project_officer.last_name}
                      </td>
                      <td>{cas.caseManager}</td>
                      <td style={{fontSize:"9px"}}>
                        <span>USD: <b>{cas.amount.toLocaleString()}</b></span><br/>
                        {cas.amount_in_local && <>
                          <span>{cas.currency}:<b>{cas.amount_in_local.toLocaleString()}</b></span><br/>
                          <span>rate <b>{cas.local_rate}</b></span><br/>
                        </>}
                      </td>
                      <td>
                        <span className={getStatusBadgeClass(cas.status)}>
                          {cas.status}
                        </span>
                      </td>
                      <td>{formatDate(cas.created_at)}</td>
                      <td>
                        <a
                          class="btn btn-primary btn-sm me-2"
                          href="javascript:void(0)"
                          data-bs-original-title=""
                          title="Edit Case"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            setModalTitle("Edit Case");
                            setEditCaseId(cas.id);
                            setCurrenctCase(cas);
                          }}
                        >
                          <i class="fa fa-pencil"></i> 
                        </a>

                        <Link
                          class="btn btn-secondary btn-sm"
                          href="javascript:void(0)"
                          data-bs-original-title=""
                          title="View Case"
                          to={`/view-case/${cas.id}`}
                        >
                          <i class="fa fa-eye"></i> 
                        </Link>
                        <button 
                          className="btn btn-danger btn-sm ms-2" 
                          title="Delete Case"
                          onClick={() => handleDelete(cas.id)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>)
        :
        (<div className="card">
            <div className="alert alert-info">
                <h3 className="text-center">
                    No Record Found
                </h3>
            </div>
        </div>)
        }
        {loading && <Loader />}
      </div>

      <Modal
        title={modalTitle}
        onSave={handleSave}
        modalId="myModal"
        modalSize="lg"
        modalPosition="centered"
      >
        <div className="row g-3">
          
          <div className="col-md-6">
            <div class="form-group">
              <label className="form-label" for="projectTitle">Title</label>
              <input
                type="text"
                class="form-control"
                id="projectTitle"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="Enter case title"
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">Currency</label>
            <select
              className="form-control"
              name="currency"
              value={formData.currency}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Currency</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="AFN">AFN</option>
            </select>
          </div>
          {formData.currency !='' && formData.currency!='USD' && 
          (<>
            <div className="col-md-6">
              <label className="form-label" for="local_rate">Local Rate</label>
                <input
                  type="text"
                  class="form-control"
                  id="localRate"
                  name="local_rate"
                  value={formData.localRate}
                  onChange={handleInputChange}
                  placeholder="Enter Local rate"
                  required
                />
            </div>
            <div className="col-md-6">
              <label className="form-label" for="local_rate">Amount In Local</label>
                <input
                  type="number"
                  class="form-control"
                  id="amountInLocalRate"
                  name="amount_in_local"
                  value={formData.amount_in_local}
                  onChange={handleInputChange}
                  placeholder="Enter Local Amount"
                  required
                />
            </div>
          </>
          )
          }
          
          <div className="col-md-6">
            <div class="form-group">
              <label className="form-label" for="amount">Amount</label>
              <input
                type="number"
                class="form-control"
                id="amount"
                name="amount"
                disabled={formData.currency != '' && formData.currency != 'USD'}
                value={formData.amount}
                onChange={handleInputChange}
                placeholder="Enter amount needed"
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label" htmlFor="created_at">Date Created</label>
              <input
                type="datetime-local"
                className="form-control"
                id="created_at"
                name="created_at"
                value={formData.created_at}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div class="form-group mb-5">
            <label for="projectDescription">Description</label>
            <ReactQuill
              theme="snow"
              value={value}
              onChange={setValue}
              style={{ height: "300px" }}
            />
          </div>

          
        </div>
      </Modal>
    </Applayout>
  );
}

export default BeneficiaryCases;
